module.exports = __webpack_public_path__ + "static/media/del_btn.e715f494.svg";